module.exports = __webpack_public_path__ + "media/bootstrap-icons/slack-723a9f6b.svg";